__turbopack_context__.v({
  "competenciesTitle": "MMIPlW_competenciesTitle",
  "sectionBackgroundColor": "MMIPlW_sectionBackgroundColor",
});
